import React from "react";
import {Resource, Resources as ResourcesType} from "../enum/Resource";
import ImageMisc from "./ImageMisc/ImageMisc";

type Props = {
    resources: ResourcesType,
}

export default function Resources({resources}: Props) {
    return <div className='d-flex align-items-center column-gap-2'>
        <div className="d-flex align-items-center column-gap-1"><ImageMisc type={"wood"} size={16} /> {resources[Resource.Wood].toLocaleString()}</div>
        <div className="d-flex align-items-center column-gap-1"><ImageMisc type={"clay"} size={16} /> {resources[Resource.Clay].toLocaleString()}</div>
        <div className="d-flex align-items-center column-gap-1"><ImageMisc type={"iron"} size={16} /> {resources[Resource.Iron].toLocaleString()}</div>
        <div className="d-flex align-items-center column-gap-1"><ImageMisc type={"crop"} size={16} /> {resources[Resource.Crop].toLocaleString()}</div>
    </div>
}
